import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import {
  COMMON_LIST_OPTIONS,
  CommonListColumn,
  CommonListComponent,
  CommonListOptions,
} from '@flexyoo/shared/ui';
import { EmployeeBudgetCurrentYearListDataSource } from './employee-budget-current-year-list.data-source';
import { EmployeeBudgetSummary } from '@flexyoo/employee/models';
import { TranslateService } from '@ngx-translate/core';
import { getEmployeeFundingTypeLabelKey } from '@flexyoo/shared/functions';

@Component({
  selector: 'flexyoo-employee-budget-current-year-list',
  templateUrl: 'employee-budget-current-year-list.component.html',
  styleUrls: ['./employee-budget-current-year-list.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonListComponent],
  providers: [
    {
      provide: COMMON_LIST_OPTIONS,
      useValue: {
        mainColumn: false,
        columnTitlePrefix: 'employee.budget',
        rowClass: (row: EmployeeBudgetSummary) =>
          row.type === 'Summary' ? 'summary-row' : undefined,
      } as CommonListOptions,
    },
  ],
})
export class FlexyooEmployeeBudgetCurrentYearListComponent {
  dataSource = new EmployeeBudgetCurrentYearListDataSource();
  translate = inject(TranslateService);
  readonly columns: CommonListColumn[] = [
    {
      id: 'type',
      type: {
        kind: 'value',
        value: (row: EmployeeBudgetSummary) =>
          this.translate.instant(
            row.type === 'Summary' ? 'funding.summary' : getEmployeeFundingTypeLabelKey(row.type)
          ),
      },
    },
    {
      id: 'assignedGrossAmount',
      type: {
        kind: 'number',
        format: 'currency',
        value: (row: any) => row.assignedBudgetAmount,
      },
    },
    {
      id: 'assignedBudgetAmount',
      type: {
        kind: 'number',
        format: 'currency',
        value: (row: any) => row.assignedGrossAmount,
      },
    },
    {
      id: 'spentBudgetAmount',
      type: {
        kind: 'number',
        format: 'currency',
        value: (row: any) => row.spentGrossAmount,
      },
    },
    {
      id: 'remainingBudgetAmount',
      type: {
        kind: 'number',
        format: 'currency',
        value: (row: any) => row.remainingGrossAmount,
      },
    },
    {
      id: 'remainingGrossAmount',
      type: {
        kind: 'number',
        format: 'currency',
        value: (row: any) => row.remainingBudgetAmount,
      },
    },
  ];
}
